import { Component } from '@angular/core';

@Component({
  selector: 'app-banner-message',
  standalone: true,
  imports: [],
  templateUrl: './banner-message.component.html',
  styleUrl: './banner-message.component.scss'
})
export class BannerMessageComponent {

}
